import { parse } from "date-fns";

const checkIfTicketInFuture = ticket => {
    const currentDate = new Date();
    const ticketInFuture = ticket.acf
        ? currentDate <
          parse(
              ticket.acf.ticket_available_from,
              "yyyy-MM-dd H:mm:ss",
              new Date()
          )
        : false;
    return ticketInFuture;
};

export default checkIfTicketInFuture;
